import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./css/carousel.css";

import ddpi1 from "../image/ddpi-banner1.svg";
import ddpi2 from "../image/ddpi-banner2.svg";
import ddpi3 from "../image/ddpi-banner3.svg";

import { Pagination, Autoplay } from "swiper/modules";

function Mobcarousel() {
  return (
    <>
      <Swiper
        cssMode={true}
        spaceBetween={0}
        speed={1500}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        
        modules={[Pagination, Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="w-fit m-auto">
            <img src={ddpi2} className="w-2/4  m-auto" alt="image"></img>

            <p className="text-base  text-center py-8 mt-3 mb-3">
              Enable DDPI in 3 steps & make your trading life easier.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-fit m-auto">
            <img src={ddpi3} className="w-full m-auto" alt="image"></img>
            <p className="text-base text-center py-8 mt-1 mb-1">
            Hassle free selling post DDPI Activation
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-fit m-auto">
            <img src={ddpi1} className="w-3/4 m-auto" alt="image"></img>
            <p className="text-base  text-center py-8 mt-3 mb-3">
              Liquidate your holdings without the necessity of daily
              <br />
              pre-authorization to sell order.
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
export default Mobcarousel;
